export const TUTORIALS_LINKS: TutorialsLang = {
	en: [
		{
			title: "Onboarding Tutorial",
			link: "https://edu.musicabinet.com/iframe/tutorial/1",
			image: "/tutorials/3.png",
		},
		{
			title: "Quick Start",
			link: "https://edu.musicabinet.com/iframe/tutorial/2",
			image: "/tutorials/2.png",
		},
		{
			title: "Welcome Video",
			link: "https://edu.musicabinet.com/iframe/tutorial/welcome1",
			image: "/tutorials/1.png",
		},
		{
			title: "Profile page and Navigation",
			link: "https://edu.musicabinet.com/iframe/tutorial/3",
			image: "/tutorials/4.png",
		},
		{
			title: "My Subscriptions",
			link: "https://edu.musicabinet.com/iframe/tutorial/4",
			image: "/tutorials/5.png",
		},
		{
			title: "My Day",
			link: "https://edu.musicabinet.com/iframe/tutorial/5",
			image: "/tutorials/6.png",
		},
		{
			title: "My Statistics",
			link: "https://edu.musicabinet.com/iframe/tutorial/6",
			image: "/tutorials/7.png",
		},
		{
			title: "Trial Period",
			link: "https://edu.musicabinet.com/iframe/tutorial/7",
			image: "/tutorials/8.png",
		},
		{
			title: "Pricing Page & Subscription Purchase",
			link: "https://edu.musicabinet.com/iframe/tutorial/8",
			image: "/tutorials/9.png",
		},
		{
			title: "GRAND CHART",
			link: "https://edu.musicabinet.com/iframe/tutorial/9",
			image: "/tutorials/10.png",
		},
		{
			title: "Backing Tracks Player",
			link: "https://edu.musicabinet.com/iframe/tutorial/10",
			image: "/tutorials/11.png",
		},
		{
			title: "Metronome",
			link: "https://edu.musicabinet.com/iframe/tutorial/11",
			image: "/tutorials/12.png",
		},
		{
			title: "Timers",
			link: "https://edu.musicabinet.com/iframe/tutorial/12",
			image: "/tutorials/13.png",
		},
		{
			title: "Lessons Navigation",
			link: "https://edu.musicabinet.com/iframe/tutorial/13",
			image: "/tutorials/14.png",
		},
		{
			title: "Education System Overview",
			link: "https://edu.musicabinet.com/iframe/tutorial/14",
			image: "/tutorials/15.png",
		},
		{
			title: "Why is our Education System so Efficient?",
			link: "https://edu.musicabinet.com/iframe/tutorial/15",
			image: "/tutorials/16.png",
		},
		{
			title: "10 Thousand Hours Concept",
			link: "https://edu.musicabinet.com/iframe/tutorial/16",
			image: "/tutorials/17.png",
		},
		/*{
			title: "REM (Rhythm Exercise Machine)",
			link: "https://edu.musicabinet.com/iframe/tutorial/17",
		},
		{
			title: "SRM (Sight Reading Machine)",
			link: "https://edu.musicabinet.com/iframe/tutorial/18",
		},
		{
			title: "IGM (Improvisational Guide Machine)",
			link: "https://edu.musicabinet.com/iframe/tutorial/19",
		},
		{
			title: "Extra Materials",
			link: "https://edu.musicabinet.com/iframe/tutorial/20",
		},*/
	],
	ru: [
		{
			title: "Обучающий ролик",
			image: "/tutorials/3.png",
			link: "https://edu.musicabinet.com/iframe/ru/tutorial/1",
		},
		{
			title: "Быстрый старт",
			link: "https://edu.musicabinet.com/iframe/ru/tutorial/2",
			image: "/tutorials/2.png",
		},
		{
			title: "Приветственное видео",
			image: "/tutorials/1.png",
			link: "https://edu.musicabinet.com/iframe/ru/tutorial/3",
		},
		{
			title: "Профиль и навигация",
			link: "https://edu.musicabinet.com/iframe/ru/tutorial/4",
			image: "/tutorials/4.png",
		},
		{
			title: "Мои подписки",
			link: "https://edu.musicabinet.com/iframe/ru/tutorial/5",
			image: "/tutorials/5.png",
		},
		{
			title: "Мой день",
			link: "https://edu.musicabinet.com/iframe/ru/tutorial/6",
			image: "/tutorials/6.png",
		},
		{
			title: "Моя статистика",
			link: "https://edu.musicabinet.com/iframe/ru/tutorial/7",
			image: "/tutorials/7.png",
		},
		{
			title: "Пробный период",
			link: "https://edu.musicabinet.com/iframe/ru/tutorial/8",
			image: "/tutorials/8.png",
		},
		{
			title: "Страница тарифов и покупка подписки",
			link: "https://edu.musicabinet.com/iframe/ru/tutorial/9",
			image: "/tutorials/9.png",
		},
		{
			title: "GRAND CHART",
			link: "https://edu.musicabinet.com/iframe/ru/tutorial/10",
			image: "/tutorials/10.png",
		},
		{
			title: "Плеер минусовок",
			link: "https://edu.musicabinet.com/iframe/ru/tutorial/11",
			image: "/tutorials/11.png",
		},
		{
			title: "Метроном",
			link: "https://edu.musicabinet.com/iframe/ru/tutorial/12",
			image: "/tutorials/12.png",
		},
		{
			title: "Таймеры",
			link: "https://edu.musicabinet.com/iframe/ru/tutorial/13",
			image: "/tutorials/13.png",
		},
		{
			title: "Навигация по урокам",
			link: "https://edu.musicabinet.com/iframe/ru/tutorial/14",
			image: "/tutorials/14.png",
		},
		{
			title: "Обзор образовательной системы",
			link: "https://edu.musicabinet.com/iframe/ru/tutorial/15",
			image: "/tutorials/15.png",
		},
		{
			title: "Почему наша система обучения так эффективна?",
			link: "https://edu.musicabinet.com/iframe/ru/tutorial/16",
			image: "/tutorials/16.png",
		},
		{
			title: "REM (Машина ритмических упражнений)",
			link: "https://edu.musicabinet.com/iframe/ru/tutorial/17",
			image: "/tutorials/17.png",
		},
		/*{
			title: "SRM (Машина чтения с листа)",
			link: "https://edu.musicabinet.com/iframe/ru/tutorial/18",
			image: "/tutorials/18.png",
		},
		{
			title: "IGM (Машина импровизации)",
			link: "https://edu.musicabinet.com/iframe/ru/tutorial/19",
			image: "/tutorials/19.png",
		},
		{
			title: "Дополнительные материалы",
			link: "https://edu.musicabinet.com/iframe/ru/tutorial/20",
			image: "/tutorials/20.png",
		},*/
	],
};

type TutorialsLangVariants = "en" | "ru";

export type TutorialsLang = {
	[K in TutorialsLangVariants]: Array<Tutorials>;
};

export interface Tutorials {
	title: string;
	link: string;
	image: string;
}
